import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { HttpResponse } from 'app/types-shared';
import { endpoints } from '../endpoints';
import { AdministrationListWire } from './types';
import { AdministrationListMessage } from './types-store';

export const api = {

  loadMessages: async (
    query: string, includeInactive: boolean, startIndex: number, maxResults: number
  ): Promise<AdministrationListWire> => {

    const response = await new RemoteAdminData(endpoints.searchMessages)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create({
        ...(!!query && {
          query: {
            text: query.trim(),
            searchInSubject: true,
            searchInMessage: true
          }
        }),
        excludeInactiveMessages: {
          enabled: !includeInactive,
          negated: false
        }
      });

    const json = await response.json();

    return json.data;
  },

  updateMessage: async (
    id: number, messageUpdate: Partial<AdministrationListMessage>
  ): Promise<AdministrationListMessage> => {
    const response = await new RemoteAdminData(endpoints.message)
      .resource<HttpResponse<AdministrationListMessage>>()
      .withId(id)
      .update(messageUpdate);

    return response.json ? response.json.data : undefined;
  },

  deleteMessage: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.message)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
